import {useEffect, useState} from "react";
import $ from "jquery";
import style from "./Calendar.module.css"
import Formatter from "../../utils/Formatter";

window.$ = $;

function Calendar(props) {

    const [className, setClassName] = useState("")

    useEffect(() => {
        prepareCalendar()
    },[props.rerender])

    useEffect(() => {
        if (props.errorClause) {
            setClassName(style.errorBorder)
        } else if (props.disabled) {
            setClassName(style.inputDataDisabled)
        } else {
            setClassName(style.inputData)
        }
        disabledCalendar()
    }, [props.errorClause, props.disabled])

    function prepareCalendar() {
        $(document).ready(function () {
            $('#' + props.id).datepicker({
                inputFormat: ["dd/MM/yyyy"],
                outputFormat: "dd/MM/yyyy"
            }).on("change", function (event) {
                if (props.onChange) {
                    return props.onChange(event.target.id, event.target.value, props.index, props.nomeOggetto)
                }
            });
        });
    }

    function disabledCalendar() {
        if (props.disabled) {
            $(document).ready(function () {
                $("#" + props.id).datepicker("disable");
            });
        } else {
            $(document).ready(function () {
                $("#" + props.id).datepicker("enable");
            });
        }
    }

    function updateCaret(event) {
        const caret = event.target.selectionStart
        let element = event.target
        let updateCaret = event.target.value.length
        if (props.value.length - event.target.value.length !== 1) {
            event.target.value =
                Formatter.formatDate(event.target.value, "dd/MM/yyyy")
        }
        updateCaret = event.target.value.length - updateCaret
        window.requestAnimationFrame(() => {
            element.selectionStart = caret + updateCaret
            element.selectionEnd = caret + updateCaret
        })
    }

    return (
        <div className={"it-datepicker-wrapper"}>
            <div className={"form-group ".concat(className)} style={{marginBottom: "0", minWidth: "180px"}}>
                {/* aria-label fornisce il nome accessibile del campo (WCAG 1.3.1 / 3.3.2):
                    la <label> sottostante e' vuota (elemento decorativo del datepicker
                    bootstrap-italia) e non produce alcun nome accessibile.
                    Attributi ARIA: nessun impatto sulla resa grafica. */}
                <input className={"form-control it-date-datepicker"}
                       id={props.id ? props.id : "date1"}
                       type="text"
                       aria-label={props.ariaLabel}
                       aria-invalid={props.errorClause ? "true" : undefined}
                       aria-describedby={props.errorClause ? `${props.id}-errore` : undefined}
                       value={props.value}
                       onChange={(event) => {
                           updateCaret(event)
                           props.onChange(event.target.id, event.target.value, props.index, props.nomeOggetto)
                       }}
                       disabled={props.disabled}
                       placeholder="gg/mm/aaaa">
                </input>
                <label htmlFor={props.id ? props.id : "date1"}/>
            </div>
            <div>
                {/* Messaggio d'errore: <span> collegato con aria-describedby anziche'
                    <label htmlFor>, che ne faceva il nome accessibile (WCAG 3.3.1). */}
                {props.errorClause ?
                    <span id={`${props.id}-errore`} role="alert" className={style.errorMessage}>{props.errorMessage}</span> : null}
            </div>
        </div>
    )


}

export default Calendar